import { render, staticRenderFns } from "./coupons-Items.vue?vue&type=template&id=06dc2cac&scoped=true&lang=pug&"
import script from "./coupons-Items.vue?vue&type=script&lang=js&"
export * from "./coupons-Items.vue?vue&type=script&lang=js&"
import style0 from "./coupons-Items.vue?vue&type=style&index=0&id=06dc2cac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc2cac",
  null
  
)

export default component.exports